import React from 'react';

import { Loading } from '../../../components';
import SourcedInfo from '../../../order/components/SourcedItem/SourcedInfo';
import SellInfo from '../../../order/components/SellItem/SellInfo';
import { PxQuotes } from './PxQuotes';

const PartXIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M12 2L2 7v10l10 5 10-5V7L12 2z"
      stroke="#7145D0"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M12 12l10-5M12 12v10M12 12L2 7" stroke="#7145D0" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
);

function PxListingCard({ item }) {
  return (
    <div className="px-listing-card">
      <div className="px-listing-card__icon">
        <PartXIcon />
      </div>
      <div className="px-listing-card__body">
        <div className="px-listing-card__title">PART-X</div>
        <div className="px-listing-card__meta">QTY: {item?.quantity || 1}</div>
      </div>
    </div>
  );
}

export function CalcSummary({
  isOrderFlow,
  openQuote,
  closeQuote,
  orderFlowQuoteId,
  orderFlowItemId,

  requestType,
  topTitle,
  order,
  product,
  request,
  mainEntries,
  pxRequests,
  pxProducts,
  client,
  getSelectionForItem,
}) {
  if (!order && !request) {
    return <Loading />;
  }

  const entries = (mainEntries ?? []).filter((e) => e?.product || e?.listing);
  const hasMulti = entries.length > 1;
  const isPxCart = requestType === 'px-cart';

  const renderListingBody = () => {
    if (isPxCart) {
      if (hasMulti) {
        return entries.map((e, i) => (
          <PxListingCard
            key={`listing-${i}-${e?.request?.id ?? e?.listing?.id ?? 'x'}`}
            item={e?.listing ? { quantity: 1, ...e.listing } : order?.items?.[i]}
          />
        ));
      }
      return (
        <PxListingCard item={order?.items?.[0]} />
      );
    }

    if (hasMulti) {
      return entries.map((e, i) => (
        <SourcedInfo
          key={`main-${i}-${e?.request?.id ?? 'x'}`}
          item={{ ...(e.request ?? {}), product: e.product, client, px_request_id: true }}
          summary
        />
      ));
    }

    return (
      <SourcedInfo item={{ ...request, product, client, px_request_id: true }} summary />
    );
  };

  return (
    <div className="request-summary px-calc-summary" data-testid="summary">
      <section className="px-calc-section">
        <h3 className="summary-header">{topTitle}</h3>
        <div className="summary-body px-calc-card px-calc-card--listing">
          {renderListingBody()}
        </div>
      </section>

      <section className="px-calc-section">
        <h3 className="summary-header">Total Sell</h3>
        {pxRequests.map((pxRequest, idx) => (
          <div className="px-calc-sell-block" key={pxRequest.id}>
            <div className="summary-body px-calc-card px-calc-card--product">
              <SellInfo
                item={{ ...pxRequest, product: pxProducts[idx], client, px_request_id: true }}
                pxRequestId={pxRequest.px_request_id}
                summary
              />
            </div>
            <PxQuotes
              bare
              item={{ ...pxRequest, product: pxProducts[idx], client, px_request_id: true }}
              getSelectionForItem={getSelectionForItem}
              isOrderFlow={isOrderFlow}
              openQuote={openQuote}
              closeQuote={closeQuote}
              orderFlowQuoteId={orderFlowQuoteId}
              orderFlowItemId={orderFlowItemId}
            />
          </div>
        ))}
      </section>
    </div>
  );
}
